export const defaultImages: string[] = [
  'https://images.dog.ceo/breeds/shiba/shiba-12.jpg',
  'https://images.dog.ceo/breeds/shiba/shiba-13.jpg',
  'https://images.dog.ceo/breeds/shiba/shiba-15.jpg',
  'https://images.dog.ceo/breeds/shiba/shiba-16.jpg',
  'https://images.dog.ceo/breeds/shiba/shiba-18.jpg',
  'https://images.dog.ceo/breeds/shiba/shiba-19.jpg',
  'https://images.dog.ceo/breeds/shiba/shiba-2.jpg',
  'https://images.dog.ceo/breeds/shiba/shiba-4.jpg',
  'https://images.dog.ceo/breeds/shiba/shiba-7.jpg',
  'https://images.dog.ceo/breeds/shiba/shiba-9.jpg',
  'https://images.dog.ceo/breeds/shiba/shiba-1.jpg',
];
